import {computed, reactive, ref} from 'vue';
import {defineStore} from "pinia";

const initialState = {
    keyword: "",
    country: "",
    state: "",
    city: "",
    status: "",
    rent_amount_per: "",
    range_fields: {
        price: {min: 0, max: 0},
        rent: {min: 0, max: 0},
        bathrooms: {min: 0, max: 0},
        bedrooms: {min: 0, max: 0},
        area: {min: 0, max: 0},
        rooms: {min: 0, max: 0},
        garages: {min: 0, max: 0},
        units: {min: 0, max: 0},
        floor_number: {min: 0, max: 0},
        year_built: {min: 0, max: 0}
    },
    property_finalizing: "",
    features: []
};

export const useSearchStore = defineStore('search', () => {

    let searchParams = reactive({...initialState});

    let sortingParams = ref({
        sortBy: 'updated_at',
        sortOrder: 'DESC'
    });

    let paginateParams = ref({
        page: 1,
        per_page: 30
    });

    const defaultLayout = ref('grid');

    const properties = ref(null);

    const loading = ref(true);

    const setSearchRange = (data) => {
        searchParams.range_fields[data.field] = data.value;
    }

    const setSearchFeatures = (data) => {
        searchParams.features = [...searchParams.features, ...data];
    }

    const setSearchFeature = (data) => {
        if(searchParams.features.find(i => i === parseInt(data)) === undefined) {
            searchParams.features = [...searchParams.features, parseInt(data)];
        }
    }

    const removeSearchFeature = (data) => {
        if(searchParams.features.find(i => i === parseInt(data)) !== undefined) {
            searchParams.features = searchParams.features.filter(i => i !== parseInt(data));
        }
    }

    const setSearchProperties = (data) => {
        properties.value = data;
    }

    const setLoading = data => {
        loading.value = data;
    }

    const setDefaultLayout = data => {
        defaultLayout.value = data;
    }

    const setPaging = data => {
        paginateParams.value = {...paginateParams.value, ...data};
    }

    const setSorting = data => {
        sortingParams.value = {...data};
    }

    // getters
    const range = (field) => {
        return [{...searchParams.range_fields[field]}.min, {...searchParams.range_fields[field]}.max];
    }

    // actions
    const search = async (params) => {
        setLoading(true);

        // call the search api
        const response = await window.axios.get('/api/search', {params});

        setLoading(false);

        if(response.status === 200) {
            setSearchProperties(response.data.properties);
        }
    }

    const bulkStoreUpdate = (queryParams) => {
        const keysUpdate = ['keyword', 'country', 'state', 'city', 'status', 'rent_amount_per', 'property_finalizing', 'features'];

        keysUpdate.forEach(key => {
            if(queryParams[key] !== undefined) {
                if(key !== 'keyword' && key !== 'property_finalizing' && key !== 'status' && key !== 'features') {
                    searchParams[key] = parseInt(queryParams[key]);
                } else if(key === 'features') {
                    searchParams[key] = queryParams['features'].split(",").map(v => parseInt(v));
                } else {
                    searchParams[key] = queryParams[key];
                }
            }
        });

        const rangeFields = ["price", "rent", "bathrooms", "bedrooms", "area", "rooms", "garages", "units", "floor_number", "year_built"];

        rangeFields.map(field => {
            if(queryParams[field]) {
                const rangeVal = queryParams[field].split(",");
                if(rangeVal[0] || rangeVal[1]) {
                    setSearchRange({field, value: {min: parseInt(rangeVal[0]), max: parseInt(rangeVal[1])}});
                }
            }
        });

        if(queryParams['layout']) {
            setDefaultLayout(queryParams['layout']);
        }

        if(queryParams['page'] || queryParams['per_page']) {
            setPaging({page: queryParams['page'] ? queryParams['page'] : paginateParams.value.page,
                per_page: queryParams['per_page'] ? queryParams['per_page'] : paginateParams.value.per_page });
        }

        if(queryParams['sorting_field'] && queryParams['sorting_order']) {
            setSorting({sortBy: queryParams['sorting_field'], sortOrder: queryParams['sorting_order']});
        }
    }

    const resetPaginateSortParams = () => {
        paginateParams.value = {page: 1, per_page: 30};
        sortingParams.value = {sortBy: 'updated_at', sortOrder: 'DESC'};
    }

    const setSearchDefaults = () => {
        resetPaginateSortParams();

        Object.assign(searchParams, {...initialState});
    }

    return {
        searchParams,
        sortingParams,
        paginateParams,
        defaultLayout,
        properties,
        loading,
        setSearchRange,
        setSearchFeature,
        removeSearchFeature,
        setSearchProperties,
        setLoading,
        setDefaultLayout,
        setPaging,
        setSorting,
        range,
        search,
        bulkStoreUpdate,
        setSearchDefaults,
        resetPaginateSortParams
    }
});
